import { render, staticRenderFns } from "./AcompanhamentoVendas.vue?vue&type=template&id=265d0336"
import script from "./AcompanhamentoVendas.vue?vue&type=script&lang=js"
export * from "./AcompanhamentoVendas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports